import classNames from "classnames";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { generatePath, Link, useHistory } from "react-router-dom";
import logo from "../../../../assets/logos/Myloc-logga.svg";
import SearchService from "../../../../services/search/SearchService";
import pages from "../../../../utils/pages";
import QRCodeButton from "../../../shared/Button/QRCodeButton";
import ScannerDialog from "../../../shared/scanner/ScannerDialog";
import CartButton from "../CartButton/CartButton";
import OrderMenu from "../OrderMenu/OrderMenu";
import ReceiverMenu from "../ReceiverMenu/ReceiverMenu";
import styles from "./MobileHeader.module.scss";

function MobileHeader() {
  const userLoggedIn = useSelector(state => state.session?.sessionId);
  const order = useSelector(state => state.appData.order);
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [scannerOpen, setScannerOpen] = useState(false);

  const closeScanner = useCallback(() => {
    setScannerOpen(false);
  }, []);

  const handleSearchResult = useCallback(
    searchResult => {
      const type = searchResult.type;
      const id = searchResult.id;

      if (type === "Item") {
        history.push({
          pathname: generatePath(pages.PRODUCT_DETAIL.PATH, {
            product: id,
          }),
        });
      } else {
        history.push({
          pathname: generatePath(pages.FIXED_ASSET_INVENTORY.PATH, {
            product: id,
          }),
        });
      }
    },
    [history],
  );

  const handleScan = useCallback(
    async scannedBarcodes => {
      if (scannedBarcodes.length === 0) return;

      setIsLoading(true);

      const result = await SearchService.getSearch(scannedBarcodes[0].rawValue);

      if (result.isOk() && result.data != null) {
        handleSearchResult(result.data);
      }

      setIsLoading(false);
      closeScanner();
    },
    [closeScanner, handleSearchResult],
  );

  return (
    <header className={classNames(styles.header)}>
      <section className={styles.topBar}>
        <figure>
          <Link to={pages.HOME}>
            <img src={logo} alt="Myloc logo" className={styles.logo} />
          </Link>
        </figure>
        {userLoggedIn && <CartButton />}
      </section>
      {userLoggedIn && (
        <>
          <section className={classNames(styles.actionBar, order?.receiver ? styles.displayGrid : styles.displayRight)}>
            <QRCodeButton onClick={() => setScannerOpen(true)} />
            {order?.receiver && <ReceiverMenu customCssClass={styles.receiverMenu} />}
            <div>
              <OrderMenu customCssClass={styles.orderMenu} />
            </div>
          </section>
          <section className={styles.searchContainer}></section>
          <ScannerDialog onScan={handleScan} open={scannerOpen} handleClose={closeScanner} isLoading={isLoading} />
        </>
      )}
    </header>
  );
}

export default MobileHeader;
